import { Route, Redirect } from "react-router-dom";
import Layout from "./components/shared/Layout";
import { useAuth } from "./context/auth";
import ErrorBoundary from "utils/errorBoundary";

const PrivateRoute = ({ component: Component, location, ...rest }: any) => {
    const {
        context: { authTokens },
    } = useAuth();
    const { search } = location;

    let renderFunc = (props: any) => (
        <Redirect
            to={{
                pathname: "/",
                state: { referer: props.location, search },
            }}
        />
    );

    if (authTokens) {
        renderFunc = (props) => (
            <Layout>
                <ErrorBoundary>
                    <Component {...props} />
                </ErrorBoundary>
            </Layout>
        );
    }
    return <Route {...rest} render={renderFunc} />;
};

export default PrivateRoute;
